import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { OfficeAction } from '../../store/actions';

class Form extends PureComponent {
  static propTypes = {
    createOffice: PropTypes.func,
    editOffice: PropTypes.func,
    getOffice: PropTypes.func,
    office: PropTypes.object,
    officeId: PropTypes.number,
    uploadLogo: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = this.getInitialState(props.office);
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    if (this.props.officeId) {
      this.props.getOffice(this.props.officeId);
    }
  }

  componentDidUpdate(props, _state, _snapshot) {
    const {
      office: {
        address: prevPropsAddress,
        logo: prevPropsLogo,
        mobile_number: prevPropsMobileNumber,
        name: prevPropsName,
      } = {},
    } = props;
    const {
      clear,
      office: {
        address: curPropsAddress,
        logo: curPropsLogo,
        mobile_number: curPropsMobileNumber,
        name: curPropsName,
      } = {},
    } = this.props;
    const {
      address: curStateAddress,
      logo: curStateLogo,
      mobile_number: curStateMobileNumber,
      name: curStateName,
    } = this.state;
    const office = {
      address: [
        prevPropsAddress !== curPropsAddress && curPropsAddress,
        clear ? '' : curStateAddress,
      ]?.find?.(i => i),
      logo: [
        prevPropsLogo !== curPropsLogo && curPropsLogo,
        clear ? '' : curStateLogo,
      ]?.find?.(i => i),
      mobile_number: [
        prevPropsMobileNumber !== curPropsMobileNumber && curPropsMobileNumber,
        clear ? '' : curStateMobileNumber,
      ]?.find?.(i => i),
      name: [
        prevPropsName !== curPropsName && curPropsName,
        clear ? '' : curStateName,
      ]?.find?.(i => i),
    };
    if (JSON.stringify(props.office) !== JSON.stringify(this.props.office)) {
      this.setState({ ...this.getInitialState(office) });
    }
  }

  getInitialState(office) {
    return {
      address: office?.address || '',
      logo: office?.logo || '',
      mobile_number: office?.mobile_number || '',
      name: office?.name || '',
    };
  }

  onChange(event) {
    const { target: { name, value } = {} } = event;
    this.setState({ [name]: value });
  }

  onClear(_) {
    this.setState(this.getInitialState());
  }

  onSubmit(event) {
    event.preventDefault();
    if (!confirm('Are you sure?')) {
      return;
    }
    if (this.props.officeId) {
      this.props.editOffice(this.props.officeId, this.state);
    } else {
      this.props.createOffice(this.state);
    }
  }

  onUpload(event) {
    const files = event.target.files;
    if (files?.length) {
      this.props.uploadLogo(files);
    }
  }

  render() {
    return (
      <div className="row">
        <div className="col">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">
                {this.props.officeId ? 'Edit' : 'Create'} Office
              </h3>
            </div>
            <form onSubmit={this.onSubmit.bind(this)}>
              <div className="card-body">
                <div className="form-row">
                  <div className="form-group col">
                    <label htmlFor="name">Name</label>
                    <input
                      className="form-control"
                      id="name"
                      name="name"
                      onChange={this.onChange}
                      placeholder="Name"
                      type="text"
                      value={this.state.name}
                    />
                  </div>
                  <div className="form-group col">
                    <label htmlFor="address">Address</label>
                    <input
                      className="form-control"
                      id="address"
                      name="address"
                      onChange={this.onChange}
                      placeholder="Address"
                      type="text"
                      value={this.state.address}
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group col">
                    <label htmlFor="mobile_number">Mobile Number</label>
                    <input
                      className="form-control"
                      id="mobile_number"
                      name="mobile_number"
                      onChange={this.onChange}
                      placeholder="Mobile Number"
                      type="text"
                      value={this.state.mobile_number}
                    />
                  </div>
                  <div className="form-group col">
                    <label htmlFor="file">Logo</label>
                    <div className="input-group">
                      <input
                        className="custom-file-input"
                        id="file"
                        onChange={this.onUpload.bind(this)}
                        type="file"
                      />
                      <label className="custom-file-label" htmlFor="file">
                        {this.state.logo || 'Choose File'}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-footer">
                <button className="btn btn-primary" type="submit">
                  Save
                </button>
                <button
                  className="btn btn-warning float-right"
                  onClick={this.onClear.bind(this)}
                  type="reset"
                >
                  Clear
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  clear: state?.office?.clear,
  office: state?.office?.detail,
  officeId: Number(props?.match?.params?.id),
});

const mapDispatchToProps = dispatch => ({
  createOffice: data => dispatch(OfficeAction.createOffice(data)),
  editOffice: (id, data) => dispatch(OfficeAction.editOffice(id, data)),
  getOffice: id => dispatch(OfficeAction.getOffice(id)),
  uploadLogo: files => dispatch(OfficeAction.uploadLogo(files)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form);
